import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

/**
 * Customized loader component for the icons in the navigation drawer.
 * It is displayed incase of unavailable data related to the specific navigation drawer.
 * @component
 * @category Components
 * @subcategory Shared
 */

const DrawerIconLoader = () => {
  return <CircularProgress style={{ color: "white", position: "absolute", left: "70px" }} size={20} />;
};

export default DrawerIconLoader;
